<template>
    <div id="wrapper">
        <div id="page-wrapper" class="body-content">
          <ConfirmDialog />
          <Toast/>
            <div class="row white-bg">
                <nav class="navbar navbar-expand-lg navbar-static-top" role="navigation">

                    <router-link v-if="true" to="/"> <!-- Verificar IsAuthenticated-->
                        <img src="../../../public/img/sgo-logoname-azul.png" height="55" alt="logo do sistema">
                    </router-link>

                    <img v-else src="../../../public/img/sgo-logoname-azul.png" height="55" alt="logo do sistema">


                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <i class="fa fa-reorder"></i>
                    </button>
                    <div class="navbar-collapse collapse" id="navbar">
                        <Menu />
                    </div>
                </nav>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="wrapper wrapper-content">
                        <slot name="contentBase">

                        </slot>
                    </div>
                </div>
            </div>
            <Rodape />
        </div>
    </div>
</template>

<script>
import Menu from './Menu.vue';
import Rodape from './Rodape.vue';

    export default {
        name: 'Base',
        components: {
            Menu,
            Rodape,
        }
    }
</script>
